import React from 'react';
import { withStyles, Tab, Tabs } from '@material-ui/core';
import { ChromeReaderMode, ListAlt, PeopleOutline, FilterNoneOutlined } from '@material-ui/icons';

const styles = theme => ({
    noProjectInfo: {
        position: 'absolute',
        top: '35%',
        left: '50%',
        transform: 'translate(-50%, 0%)'
    },
    noProjectText: {
        textAlign: 'center'
    }
});
class HeaderTabs extends React.Component {

    render() {
        return (
            <React.Fragment>
                <Tabs
                    value={this.props.role}
                    onChange={this.props.onChangeRole}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    <Tab value='dashboard' label="Projekte" icon={<img src={require('../../icons/box.svg')} height="18" width="18" alt="Manager" />} />
                    <Tab value='tasks' label="Tasks" icon={<img src={require('../../icons/tasks.svg')} height="18" width="18" alt="Tasks" />} />
                    <Tab value='team' label="Team" icon={<img src={require('../../icons/users.svg')} height="18" width="18" alt="Users" />} />
                    <Tab value='documents' label="Dokumente" icon={<FilterNoneOutlined style={{ fontSize: '18px' }} />} />
                </Tabs>
            </React.Fragment>
        );
    }
}


export default withStyles(styles)(HeaderTabs);



// WEBPACK FOOTER //
// ./src/components/common/HeaderTabs.js